
const API_URL = "https://apiv2.zemus.info" //"http://zemus.info:8080"
const API_SCHEME = "https"
const API_HOST_NAME = "apiv2.zemus.info"
const API_PORT =  "51682"

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    API_URL,
    API_SCHEME,
    API_HOST_NAME,
    API_PORT
};



